export default {
  namespaced: true,
  state: {
    items: [],
    dialogEmpleadoDestacado: false,
    itemEmpleadoDestacado: [],
  },
  mutations: {
    setItems(state, payload) {
      state.items = payload;
    },
    setModel(state, payload) {
      state.model = payload;
    },
    setDialogEmpleadoDestacado(state, payload) {
      state.dialogEmpleadoDestacado = payload;
    },
    setItemEmpleadoDestacado(state, payload) {
      state.itemEmpleadoDestacado = payload;
    },
  },
};
